module.exports = __webpack_public_path__ + "media/promo/hochland/images/ball1-cf6846223169751cf7bae3021f60e4ae.png";